import axios from 'axios'

export default {

  //转移人员
  transferStaff(roleType) {
    return axios.get('group/get_all_group_staff_by_role', {
      //return axios.get('group/get_group_staff_by_role', {
      params: {
        role: roleType
      }
    })
  },

  //提报人
  allStaff(){
    return axios.get('group/get_all_group_staff_list')
  },

  //提报人 带参数
  allStaffRole(roleType){
    return axios.get('group/get_all_group_staff_by_role',{
      params:{
        role:roleType,
      }
    })
  },

  //提报人
  allPayStaff(){
    return axios.get('shop/get_shop_staff_list')
  },

  //门店门市
  shopReceptorId(){
    return axios.get('group/get_msjd_staff_list')
  }
}



// WEBPACK FOOTER //
// ./src/api/functionArea.js